import { useState } from 'react';
import Box from '@mui/material/Box';
import ClickAwayListener from '@mui/material/ClickAwayListener';

export const withChildren = (Component: any) => (props: any) => {
  const [showSearchComponent, setShowSearchComponent] = useState(false);

  if (!props?.children) return <Component {...props} />;

  if (props?.children && showSearchComponent) {
    return (
      <ClickAwayListener
        onClickAway={() => {
          setShowSearchComponent(false);
        }}
      >
        <Component
          {...props}
          onClose={() => {
            setShowSearchComponent(false);

            if (props.onClose) {
              props.onClose();
            }
          }}
        />
      </ClickAwayListener>
    );
  }

  return (
    <Box
      onClick={() => {
        setShowSearchComponent(true);
      }}
      onFocus={() => {
        setShowSearchComponent(true);
      }}
    >
      {props?.children}
    </Box>
  );
};
